export default __webpack_public_path__ + "static/media/massup_l3.b55e36d5.png";